import React, { Component } from 'react';
import 'carbon-components/css/carbon-components.css';
import './scss/custom.scss';
import './scss/theme.scss';
import './scss/react-dual-listbox.scss';
import { Loading } from 'carbon-components-react';
import { authProvider } from './auth/authProvider';
import { Layout } from './components/Layout';

import { AppContext } from './helpers/context/AppContext';
import { Authorization } from './helpers/authorization/Authorization';
import { me } from './helpers/api/api';
import CacheStorage from './helpers/api/CacheStorage';
import AuditRepository from './helpers/api/AuditRepository';
import IncidentRepository from './helpers/api/IncidentRepository';
import MeRepository from './helpers/api/MeRepository';
import ReportRepository from './helpers/api/ReportRepository';
import HocCardRepository from './helpers/api/HocCardRepository';
import TrainingRepository from './helpers/api/TrainingRepository';
import InspectionRepository from './helpers/api/InspectionRepository';
import DrillRepository from './helpers/api/DrillRepository';

export default class App extends Component {
  displayName = App.name;
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      user: {},
      settings: {},
    };
    this.getUser = this.getUser.bind(this);
    this.getUser();
    this.cacheStorage = new CacheStorage();
    this.auditRepository = new AuditRepository();
    this.cacheStorage.flushQueue();
    // console.log(authProvider);
  }

  getUser = async () => {
    const res = await me
      .getMe()
      .then((response) => {
        this.setState({ user: response.data, loading: false });
      })
      .catch(() => {
        this.setState({ user: null, loading: false });
      });
  };

  render() {
    let content = null;
    if (this.state.loading) {
      content = (
        <div className="loginSpinner">
          <Loading withOverlay={false} className="login" />
        </div>
      );
    } else {
      const LayoutAuthorized = Authorization(this.state.user, Layout, 'Global', null, true);
      // if (this.state.user && this.state.user.modules) {
      //   let delta = 3000;
      //   setTimeout(() => {
      //     MeRepository.preFetch();
      //   }, (delta += 3000));
      //   if (this.state.user.modules.includes('Audit')) {
      //     setTimeout(() => {
      //       this.auditRepository.fetchAudit();
      //     }, (delta += 30000));
      //   }
      //   if (this.state.user.modules.includes('Incident')) {
      //     setTimeout(() => {
      //       IncidentRepository.fetchIncident();
      //     }, (delta += 30000));
      //   }
      //   if (this.state.user.modules.includes('Report')) {
      //     setTimeout(() => {
      //       ReportRepository.preFetch();
      //     }, (delta += 30000));
      //   }
      //   if (this.state.user.modules.includes('Hoc Card')) {
      //     setTimeout(() => {
      //       HocCardRepository.preFetch();
      //     }, (delta += 30000));
      //   }
      //   if (this.state.user.modules.includes('Training')) {
      //     setTimeout(() => {
      //       TrainingRepository.fetchTraining();
      //     }, (delta += 30000));
      //   }
      // if (this.state.user.modules.includes('Inspection')) {
      //   setTimeout(() => {
      //     InspectionRepository.preFetch();
      //   }, (delta += 30000));
      // }
      //   if (this.state.user.modules.includes('Emergency Drill')) {
      //     setTimeout(() => {
      //       DrillRepository.preFetch();
      //     }, (delta += 30000));
      //   }
      // }
      content = (
        <AppContext.Provider value={{ user: this.state.user }}>
          <LayoutAuthorized />
        </AppContext.Provider>
      );
    }
    return content;
  }
}
